// Formatage des dates en français (timezone Europe/Brussels, dates métier naïves)
import { format } from "date-fns";
import { fr } from "date-fns/locale";

// Date longue : « lundi 13 juillet 2026 »
export const formatLong = (s) => (s ? format(new Date(s), "EEEE d MMMM yyyy", { locale: fr }) : "");

// Date courte : « lun. 13 juil. »
export const formatCourt = (s) => (s ? format(new Date(s), "EEE d MMM", { locale: fr }) : "");

// « 13 juillet 2026 »
export const formatJour = (s) => (s ? format(new Date(s), "d MMMM yyyy", { locale: fr }) : "");

export const formatHeure = (s) => (s ? format(new Date(s), "HH'h'mm", { locale: fr }) : "");

export const formatDateHeure = (s) =>
  s ? format(new Date(s), "EEE d MMM 'à' HH'h'mm", { locale: fr }) : "";

// "YYYY-MM-DD" du jour (heure locale)
export const aujourdHuiISO = () => format(new Date(), "yyyy-MM-dd");

// Une échéance "YYYY-MM-DD" est-elle dépassée ?
export const estEnRetard = (echeance) => Boolean(echeance) && echeance < aujourdHuiISO();

// Jours restants avant Petero Nzukira (30 octobre 2026)
export const joursAvantSpectacle = () => {
  const diff = new Date("2026-10-30T20:00") - new Date();
  return Math.max(0, Math.ceil(diff / (1000 * 60 * 60 * 24)));
};
